import React, { Component } from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux'
import autobind from 'autobind-decorator'
import {findViewChannelLabel} from "./Utils";

@connect(state => ({
    viewChannels: state.category.viewChannels,
}), dispatch => ({
    dispatch
}))
class ViewChannelSelection extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open_layer : false,
      openedParentViewChannelCategoryId : null
    };
  }

  componentDidMount() {
    const { viewChannels, selected } = this.props;
    viewChannels.map((item) => {
      if (selected && item.children && !!item.children.find(c => c.id === selected)) {
        this.handleOpenParentViewChannelCategory(item.id);
      }
    });
  }

  @autobind
  toggleLayer() {
    const { open_layer } = this.state;

    this.setState( {
      open_layer : !open_layer,
    });
  }

  @autobind
  handleOpenParentViewChannelCategory(itemId) {
    this.setState( {
      openedParentViewChannelCategoryId: itemId
    });
  }

  @autobind
  handleSelectionItem(itemId) {
    const { selectChannel} = this.props;
    selectChannel(itemId);
    this.handleOpenParentViewChannelCategory(null);
    this.toggleLayer();
  }

  render() {
    const { viewChannels, selected } = this.props;
    const { open_layer, openedParentViewChannelCategoryId } = this.state;

    const selectedLabel = findViewChannelLabel(selected, viewChannels);

    return (
      <div className={classnames('opt_blog', {'opt_open' : open_layer})}>
        <button type="button" className="btn_opt" onClick={() => this.toggleLayer()}>
          { selectedLabel }
          <span className="ico_blog ico_open"/>
        </button>
        <div className="layer_opt">
          <ul className="list_opt">
            <ListItem
              item={{id: null, label: '주제 없음'}} selectedId={selected} focusId={openedParentViewChannelCategoryId}
              onFocus={() => this.handleOpenParentViewChannelCategory(null)}
              onSelect={() => this.handleSelectionItem(null)}
            />
            {viewChannels.map((item) =>
              <ListItem
                key={item.id}
                item={item} selectedId={selected} focusId={openedParentViewChannelCategoryId}
                onFocus={() => this.handleOpenParentViewChannelCategory(item.id)}
                onSelect={this.handleSelectionItem}
              />
            )}
          </ul>
        </div>
      </div>
    );
  }
}

function ListItem(props) {
  const { item, selectedId, focusId, onFocus, onSelect } = props;
  const className = classnames({
    "on": item.id === selectedId || (item.children && !!item.children.find(c => c.id === selectedId)),
    "sub_open" : item.id === focusId
  });
  return (
    <li key={item.id} className={className} onMouseOver={() => onFocus(item)} onFocus={() => onFocus(item)}>
      <label className="lab_btn">
        {item.label}
        {item.children && <span className="ico_blog ico_arr"/>}
        <input type="button" name={item.name} className="btn_g" defaultValue={item.label} onClick={() => {if (!item.children) { onSelect(item.id) }}}/>
      </label>
      {item.children &&
        <div className="layer_opt">
          <ul className="list_opt">
            {item.children.map((subItem, idx) =>
              <ListItem
                key={subItem.id}
                item={subItem} selectedId={selectedId}
                onFocus={() => {}}
                onSelect={onSelect}
              />
            )}
          </ul>
        </div>
      }
    </li>
  );
}


export default ViewChannelSelection;
